module.exports = __webpack_public_path__ + "static/img/upload-ios.6f85050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload-ios.png
// module id = grOK
// module chunks = 1